import { render, staticRenderFns } from "./UnbindErpBox.vue?vue&type=template&id=2f025bc0&scoped=true"
import script from "./UnbindErpBox.vue?vue&type=script&lang=js"
export * from "./UnbindErpBox.vue?vue&type=script&lang=js"
import style0 from "./UnbindErpBox.vue?vue&type=style&index=0&id=2f025bc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f025bc0",
  null
  
)

export default component.exports